import { useState, type FC } from 'react'
import { useRouter } from '@egw/router'
import { Button, GenericError, ModalDrawer } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { useSubmitEnrollmentApplicationData } from '@egw/api'
import { log } from '@egw/logger'

interface EnrollmentHeaderProps {
  exitLink: string
}

export const EnrollmentHeader: FC<EnrollmentHeaderProps> = ({ exitLink }) => {
  // Modal
  const { t } = useTranslation('layouts')
  const { navigate } = useRouter()
  const [showModal, setShowModal] = useState<boolean>(false)
  const { mutate: submit, isLoading: isSubmitting, error: submitError } = useSubmitEnrollmentApplicationData()

  const onAbandonApplication = async () => {
    try {
      await submit({
        abandonApplication: true,
      })
      navigate(exitLink)
    } catch (err) {
      log.error('Error abandoning application', err)
    }
  }

  return (
    <>
      <div className="w-full h-[41px] bg-white items-center gap-sm justify-end flex border-light border-b">
        <div
          onClick={() => {
            setShowModal(true)
          }}
          className="cursor-pointer"
          id="close-enrollment-btn"
          data-testid="close-enrollment-btn"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="cursor-pointer"
            id="close-enrollment-icon"
          >
            <path
              d="M24.7148 14.2116C24.9955 13.9295 25.4506 13.9295 25.7313 14.2116C26.012 14.4936 26.012 14.951 25.7313 15.233L21.0165 19.9708L25.7895 24.767C26.0702 25.049 26.0702 25.5064 25.7895 25.7884C25.5088 26.0705 25.0536 26.0705 24.7729 25.7884L20 20.9923L15.2271 25.7884C14.9464 26.0705 14.4912 26.0705 14.2105 25.7884C13.9298 25.5064 13.9298 25.049 14.2105 24.767L18.9835 19.9708L14.2687 15.233C13.988 14.951 13.988 14.4936 14.2687 14.2116C14.5494 13.9295 15.0045 13.9295 15.2852 14.2116L20 18.9493L24.7148 14.2116Z"
              fill="#B6B9B7"
            />
          </svg>
        </div>
      </div>
      {/* Modal */}
      <ModalDrawer
        onClose={() => {
          setShowModal(false)
        }}
        title={t(`header.are_you_sure`)}
        isOpen={showModal}
      >
        <div className="flex flex-col gap-2 mt-xs">
          <Button variant="primary" onClick={onAbandonApplication}>
            {t(`navigation.yes_exit`)}
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModal(false)
            }}
          >
            {t(`navigation.no_go_back`)}
          </Button>

          {!isSubmitting && submitError ? (
            <div className="flex-1 flex flex-col justify-start md:justify-center">
              <GenericError errorMessage={t('common.generic_error')} />
            </div>
          ) : null}
        </div>
      </ModalDrawer>
    </>
  )
}
